// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryCommsMobileTable_root__2J11t"};